import { atom } from "recoil";


export const sideMenuState = atom({
    key: 'sideMenuState',
    default: undefined,
    
});